import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=b2ba7800&scoped=true"
import script from "./textarea.vue?vue&type=script&lang=js"
export * from "./textarea.vue?vue&type=script&lang=js"
import style0 from "./textarea.vue?vue&type=style&index=0&id=b2ba7800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ba7800",
  null
  
)

export default component.exports